/**
 * Removes the first element that matches the predicate from the given array
 *
 * @example
 * const array = [{id: 1, name: "Bob"}, {id: 2, name: "Steve"}, {id: 3, name: "Gary"}]
 * const removed = removeFirstOccurrence(array, x => x.id === 2)
 * console.log(array) // output = [{id: 1, name: "Bob"}, {id: 3, name: "Gary"}]
 * console.log(removed) // output = {id: 2, name: "Steve"}
 *
 * @param array the array to update
 * @param predicate A function to execute on each value in the array until the function returns true, indicating that the satisfying element was found.
 * @returns the removed element or null if nothing was removed
 */
export const removeFirstOccurrence = <T>(
  array: T[],
  predicate: (value: T, index: number, array: T[]) => unknown
): T | null => {
  const firstOccurrenceIndex = array.findIndex(predicate);
  if (firstOccurrenceIndex !== -1) {
    return array.splice(firstOccurrenceIndex, 1)[0] ?? null;
  }

  return null;
};
